import { Label } from '@components/UI-Components/Label'
import { TableViewColumnDefinition } from '@components/UI-Components/StandardTableView/models/TableViewColumnDefinition'
import { FontTShirtSize } from '@modules/common/models/enums/FontSize'
import React from 'react'

/**
 * Class with methods for returning components required to render product cell
 */
class ClientSearchViewComponentService {
  getSearchWidgetLabelComponent = (
    rowData: any,
    columnDefinition: TableViewColumnDefinition
  ) => {
    return (
      <Label
        fontSize={FontTShirtSize.md}
        cellPadding={'0px'}
        cursor={'pointer'}
        value={rowData[columnDefinition.node.key]}
        onClick={
          columnDefinition.props.onClick
            ? columnDefinition.props.onClick(rowData)
            : undefined
        }
      />
    )
  }
}

export const clientSearchViewComponentService = new ClientSearchViewComponentService()
